export  const MakeCustomDimension = () => {

    let date = new Date();
    let mesActual = (`0${date.getMonth() + 1}`).slice(-2);
    let mesNotasLeidas = localStorage.getItem("mesNotasLeidas");
    if (mesNotasLeidas !== null) {
        if (mesActual === mesNotasLeidas) {
            addNotaRead();
        } else {
            localStorage.removeItem("mesNotasLeidas");
            localStorage.removeItem("CDnotasLeidas");
            localStorage.setItem("mesNotasLeidas", mesActual);
            addNotaRead();
        }
    } else {
        localStorage.setItem("mesNotasLeidas", mesActual);
        addNotaRead();
    }

}

const addNotaRead = () => {
    let lSnotasLeidas = localStorage.getItem("CDnotasLeidas");

    lSnotasLeidas = lSnotasLeidas ? lSnotasLeidas : 0;

    lSnotasLeidas = parseInt(lSnotasLeidas) + 1;
    localStorage.setItem("CDnotasLeidas" ,lSnotasLeidas);

}





// WEBPACK FOOTER //
// ./Statics/scripts/nota/NotaCustomDimension.js